import { graphql } from 'react-relay';

export const updateEmploymentQuery = graphql`
  mutation employmentUpdateMutation(
    $surveyAnswerId: String!
    $isCompleted: Boolean!
    $hasSpecialRelationshipsInThePast: YesNoBlank
    $specialRelationshipsInThePast: [SurveyEmployeeInput!]
    $specialRelationshipsCurrently: [EmployeeWithoutTinInput!]
    $hasEmploymentContracts: EmploymentContractsType
  ) {
    upsertEmploymentAnswer(
      surveyAnswerId: $surveyAnswerId
      isCompleted: $isCompleted
      hasSpecialRelationshipsInThePast: $hasSpecialRelationshipsInThePast
      specialRelationshipsInThePast: $specialRelationshipsInThePast
      specialRelationshipsCurrently: $specialRelationshipsCurrently
      hasEmploymentContracts: $hasEmploymentContracts
    ) {
      result
      errors {
        code
        message
      }
    }
  }
`;

export const updateSpecialRelationshipsPastQuery = graphql`
  mutation employmentSpecialRelationshipsPastMutation(
    $surveyAnswerId: String!
    $isCompleted: Boolean!
    $hasSpecialRelationshipsInThePast: YesNoBlank
    $specialRelationshipsInThePast: [SurveyEmployeeInput!]
    $specialRelationshipsCurrently: [EmployeeWithoutTinInput!]
  ) {
    upsertEmploymentAnswer(
      surveyAnswerId: $surveyAnswerId
      isCompleted: $isCompleted
      hasSpecialRelationshipsInThePast: $hasSpecialRelationshipsInThePast
      specialRelationshipsInThePast: $specialRelationshipsInThePast
      specialRelationshipsCurrently: $specialRelationshipsCurrently
    ) {
      result
      errors {
        code
        message
      }
    }
  }
`;

export const updateSpecialRelationshipsPastToCurrentlyQuery = graphql`
  mutation employmentSpecialRelationshipsPastToCurrentlyMutation(
    $surveyAnswerId: String!
    $isCompleted: Boolean!
    $specialRelationshipsCurrently: [EmployeeWithoutTinInput!]
  ) {
    upsertEmploymentAnswer(surveyAnswerId: $surveyAnswerId, isCompleted: $isCompleted, specialRelationshipsCurrently: $specialRelationshipsCurrently) {
      result
      errors {
        code
        message
      }
    }
  }
`;

export const updateSpecialRelationshipsCurrentQuery = graphql`
  mutation employmentSpecialRelationshipsCurrentMutation(
    $surveyAnswerId: String!
    $isCompleted: Boolean!
    $specialRelationshipsCurrently: [EmployeeWithoutTinInput!]
  ) {
    upsertEmploymentAnswer(surveyAnswerId: $surveyAnswerId, isCompleted: $isCompleted, specialRelationshipsCurrently: $specialRelationshipsCurrently) {
      result
      errors {
        code
        message
      }
    }
  }
`;

export const updateEmploymentContractsQuery = graphql`
  mutation employmentContractsMutation($surveyAnswerId: String!, $isCompleted: Boolean!, $hasEmploymentContracts: EmploymentContractsType) {
    upsertEmploymentAnswer(surveyAnswerId: $surveyAnswerId, isCompleted: $isCompleted, hasEmploymentContracts: $hasEmploymentContracts) {
      result
      errors {
        code
        message
      }
    }
  }
`;
